import { useTranslation } from 'react-i18next';
import { IconAlertTriangle } from '@tabler/icons-react';
import GateBanner from '@/components/common/GateBanner';
import { ROUTES } from '@/routes/paths';

// Ограничение создания предложений о продаже до аттестации: не аттестованный продавец видит баннер
// вместо действия создания (просмотр рынка остаётся доступен). Вид — общий GateBanner, диплинк в
// «Моя компания → Аттестация».
export default function SellAttestationGate() {
  const { t } = useTranslation();
  return (
    <GateBanner
      icon={<IconAlertTriangle size={20} />}
      to={ROUTES.APP_COMPANY_ACCREDITATION}
      title={t('app.sell.attestationGate.title')}
      text={t('app.sell.attestationGate.text')}
      action={t('app.sell.attestationGate.action')}
    />
  );
}
